import moment from "moment";
import { SENTIMENT_ACTION } from "./actions";
import { IData } from "../web/common";
import klineInterval from "../Params";

const DATA_COUNT = 2;
const COLLECTION_NAME = "NS_CRP_LINES_DATE_LIST";

interface IXUData {
  linesDates: IData[];
  requested: boolean;
  loaded: boolean;
}

const initialState: IXUData = {
  linesDates: [],
  requested: false,
  loaded: false,
};

export function loadLinesDates(firebase: any, historyDate: Date | null= null) {
  return async function thunk(dispatch: any, getState: any) {
    historyDate = historyDate ?? new Date();
    const state = getState();
    if (state.LinesDates.requested && state.selectedDate == historyDate) return;
    dispatch({
      type: SENTIMENT_ACTION.NS_LINES_DATE_LIST,
      payload: { requested: true, loaded: false, sentiment: [] },
    });

    firebase
      .firestore()
      .collection(`${COLLECTION_NAME}${klineInterval}`)
      .orderBy("dateTime", "desc")
      .where("dateTime", "<=", historyDate)
      .limit(DATA_COUNT)
      .onSnapshot((querySnapshot: any) => {
        var data: Object[] = [];

        querySnapshot.forEach(function (doc: any) {
          // linesDatesData = doc.data().dateList;
          var items = doc.data().dateList;
          data.push({
            UpdateTime: doc.data().dateTime.seconds,
            dates: items
          });
        });
        dispatch({
          type: SENTIMENT_ACTION.NS_LINES_DATE_LIST,
          payload: {
            linesDates: data,
            loaded: true,
            requested: true,
            selectedDate: historyDate
          },
        });
      });
  };
}

export default function LinesDates(state = initialState, action: any) {
  switch (action.type) {
    case SENTIMENT_ACTION.NS_LINES_DATE_LIST:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
export const linesDatesSelector = (state: any) => state.LinesDates;
